import { Brain } from 'lucide-react';

export default function WelcomeMessage() {
  return (
    <div className="bg-bg-tertiary border border-border-subtle rounded-xl p-8 text-center text-text-muted">
      <Brain
        className="text-accent-blue mx-auto mb-3 opacity-80"
        size={32}
      />
      <h3 className="text-[15px] font-semibold text-text-primary mb-2">
        Ares Fleet Intelligence
      </h3>
      <p className="text-xs text-text-secondary leading-relaxed">
        Consulta el estado de tu flota, analiza riesgos, visualiza rutas y mucho
        más. Escribe tu pregunta abajo.
      </p>
    </div>
  );
}
